// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ExecutionTypeSchema = z.enum(['ATTACK','SIGNAL_GENERATION','JUDGE','AI_DISCOVERY','AUTHENTICATION_DISCOVERY'] as const);

export type ExecutionTypeType = `${z.infer<typeof ExecutionTypeSchema>}`

export default ExecutionTypeSchema;
